import type { MaintenanceChecklistItem } from '../../types/maintenance';

export default function ChecklistSummary({ items }: { items: MaintenanceChecklistItem[] }) {
  if (!items.length) return null;
  return <section className="mb-8">
    <h3 className="font-semibold text-lg mb-3">Checklist mensual ({items.filter(item => item.completed_at).length}/{items.length})</h3>
    <ul className="space-y-2">{items.map(item => <li key={item.id}>
      <span>{item.completed_at ? '✓ Completada' : '○ Pendiente'} · {item.title}</span>
      {item.completed_at && <span className="block text-sm text-gray-500">{item.completed_by_name} · {new Date(item.completed_at).toLocaleString('es-ES', { timeZone: 'Europe/Madrid' })}</span>}
    </li>)}</ul>
  </section>;
}
